module.exports = __webpack_public_path__ + "img/种植主题图标.279b01e0.svg";